import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3402';

export const statementsService = {
  async getMonthly(year: number, month: number) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/statements/monthly`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { year, month },
    });
    return res.data as { statement: any };
  },

  async downloadCSV(year: number, month: number) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/statements/monthly/csv`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { year, month },
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `statement-${year}-${String(month).padStart(2, '0')}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },
};


